import ProfileMenu from "../ProfileMenu";
import "./Header.css";

const Header = (props) => {
    const { children } = props;

    return (
        <div className="header">
            <div className="header__content">
                {children}
            </div>
            <div className="header__user-name">
                <ProfileMenu />
            </div>
        </div>
    );
};

export default Header;
